module.exports = __webpack_public_path__ + "static/media/information_widget.eaf24ccc.jpg";